import React, { FC } from 'react';

import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Icon from 'components/Icon';

type Props = {
  name: string;
  icon?: string | null;
} & MenuItemProps;

const MultiSelectMenuItem: FC<Props> = ({ icon, name, ...props }) => (
  <MenuItem {...props}>
    {icon && (
      <ListItemIcon>
        <Icon icon={icon} />
      </ListItemIcon>
    )}
    {name}
  </MenuItem>
);

export default MultiSelectMenuItem;
